import _taggedTemplateLiteral from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _asyncToGenerator from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";

var _templateObject, _templateObject2;

import _regeneratorRuntime from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import React, { useState } from 'react';
import styled from 'styled-components';
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import { getRadii, getSpace, getZIndex, getColor } from '@yoweb/ui/styles/utils/theme';
import { useTranslation, Trans } from '@yoweb/next-i18next';
import { media, pxToRem } from '@yoweb/ui/styles/utils';
import { Container } from '@yoweb/ui/components/containers/Container';
import { Label, Title, Text } from '@yoweb/ui/components/typography';
import Input from '@yoweb/ui/components/form/Input';
import { Button } from '@yoweb/ui/components/buttons';
import { Box } from '@yoweb/ui/components/Box';
import { PAGE_PRIVACY_POLICY } from '@store/constants/routes';
import { useIntlMeta } from '@yoweb/ui/hooks/useIntlMeta';
import { importBraze } from '@yoweb/ui/hooks/useBraze';
import hasFullWidthChars from '@yoweb/utils/intl/hasFullWidthChars';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var NewsletterBox = function NewsletterBox() {
  var _useState = useState(false),
      isComplete = _useState[0],
      setIsComplete = _useState[1];

  var _useTranslation = useTranslation(['common']),
      t = _useTranslation.t;

  var _useIntlMeta = useIntlMeta(),
      localeHasFullWidthChars = _useIntlMeta.localeHasFullWidthChars;

  var validationSchema = Yup.object({
    email: Yup.string().trim().test({
      message: t('common:validation.enter-half-width-characters'),
      test: function test(value) {
        return value && localeHasFullWidthChars ? !hasFullWidthChars(value) : true;
      }
    }).email(t('common:validation.enter-valid-address')).required(t('common:validation.required'))
  });

  var handleSubmitNewsletterForm = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(values, actions) {
      var braze, user;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return importBraze();

            case 2:
              braze = _context.sent;
              user = braze.getUser();

              if (user) {
                _context.next = 6;
                break;
              }

              throw new Error('Braze failed to initialize, unable to save newsletter submission.');

            case 6:
              user.setEmail(values.email);
              user.setCustomUserAttribute('newsletter_lead', true);
              braze.requestImmediateDataFlush(function (flushSuccess) {
                if (flushSuccess) {
                  setIsComplete(true);
                }

                actions.setSubmitting(false);
              });

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleSubmitNewsletterForm(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_jsx(Container, {
    "data-testid": "newsletter-box",
    fillTabletWidth: true,
    children: /*#__PURE__*/_jsx(Box, {
      position: "relative",
      mt: {
        _: 24,
        lg: 80
      },
      mb: {
        _: 24,
        lg: 0
      },
      children: /*#__PURE__*/_jsx(NewsletterPosition, {
        children: /*#__PURE__*/_jsxs(NewsletterBoxPlaceholder, {
          children: [/*#__PURE__*/_jsx(Label, {
            textAlign: "center",
            size: "md",
            as: "p",
            $textTransform: "uppercase",
            children: t('common:footer.newsletter-box.headline')
          }), /*#__PURE__*/_jsxs(Box, {
            position: "relative",
            children: [/*#__PURE__*/_jsxs(Box, {
              visibility: isComplete ? 'hidden' : 'visible',
              children: [/*#__PURE__*/_jsx(Box, {
                width: "100%",
                mt: {
                  _: 'normal1',
                  lg: 'normal2'
                },
                children: /*#__PURE__*/_jsx(Title, {
                  textAlign: "center",
                  size: {
                    _: 'sm',
                    lg: 'md'
                  },
                  children: /*#__PURE__*/_jsx(Trans, {
                    t: t,
                    i18nKey: "common:footer.newsletter-box.message",
                    components: [/*#__PURE__*/_jsx(Box, {
                      display: {
                        _: 'block',
                        md: 'none'
                      },
                      as: "span",
                      children: /*#__PURE__*/_jsx("br", {})
                    }, 0)]
                  })
                })
              }), /*#__PURE__*/_jsx(Formik, {
                initialValues: {
                  email: ''
                },
                onSubmit: handleSubmitNewsletterForm,
                validationSchema: validationSchema,
                children: function children(_ref2) {
                  var isSubmitting = _ref2.isSubmitting;
                  return /*#__PURE__*/_jsx(Form, {
                    children: /*#__PURE__*/_jsxs(Box, {
                      mt: {
                        _: 'normal1',
                        lg: 'normal3'
                      },
                      maxWidth: 340,
                      mx: "auto",
                      children: [/*#__PURE__*/_jsx(Input, {
                        id: "newsletter-email",
                        type: "text",
                        label: t('common:footer.newsletter-box.email-label'),
                        name: "email",
                        enforceCharacterWidth: "half",
                        "data-testid": "newsletter-email"
                      }), /*#__PURE__*/_jsx(Box, {
                        display: "flex",
                        justifyContent: "center",
                        mt: {
                          _: 'normal1',
                          lg: 'normal3'
                        },
                        children: /*#__PURE__*/_jsx(Button, {
                          isLoading: isSubmitting,
                          type: "submit",
                          variant: "primary",
                          weight: "bold",
                          size: "lg",
                          "data-testid": "newsletter-submit",
                          children: t('common:footer.newsletter-box.form-cta')
                        })
                      })]
                    })
                  });
                }
              }), /*#__PURE__*/_jsx(Box, {
                mt: {
                  _: 'normal1',
                  lg: 'normal3'
                },
                children: /*#__PURE__*/_jsx(Text, {
                  size: "sm",
                  textAlign: "center",
                  children: /*#__PURE__*/_jsx(Trans, {
                    t: t,
                    i18nKey: "common:footer.newsletter-box.disclaimer",
                    components: [/*#__PURE__*/_jsx(Box, {
                      display: {
                        _: 'block',
                        md: 'none'
                      },
                      as: "span",
                      children: /*#__PURE__*/_jsx("br", {})
                    }, 0), /*#__PURE__*/_jsx(Text, {
                      as: "a",
                      href: PAGE_PRIVACY_POLICY,
                      size: "sm",
                      variant: "fg",
                      textDecoration: "underline",
                      target: "_blank"
                    }, 1)]
                  })
                })
              })]
            }), /*#__PURE__*/_jsx(Box, {
              display: isComplete ? 'grid' : 'none',
              position: "absolute",
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
              justifyContent: "center",
              alignItems: "center",
              children: /*#__PURE__*/_jsx(Title, {
                size: "md",
                textAlign: "center",
                "data-testid": "newsletter-success",
                children: t('common:footer.newsletter-box.message-success')
              })
            })]
          })]
        })
      })
    })
  });
};

var NewsletterPosition = styled.div.withConfig({
  componentId: "sc-1gbs428-0"
})(["position:relative;width:100%;margin:0 auto;", ""], media.lg(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    position: absolute;\n    margin: 0 auto ;\n    right: 0;\n    top: -", ";\n    margin: 0 auto ;\n    width: ", "; \n    z-index: ", ";\n  "])), "".concat(pxToRem(72)), pxToRem(392), getZIndex('above')));
var NewsletterBoxPlaceholder = styled.div.withConfig({
  componentId: "sc-1gbs428-1"
})(["border-radius:", ";background:", ";padding:", " ", ";z-index:", ";", ""], getRadii('medium'), getColor('frost'), getSpace('normal4'), getSpace('normal2'), getZIndex('above'), media.lg(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    padding: ", " ", ";\n  "])), getSpace('normal4'), getSpace('normal3')));
export default NewsletterBox;